import { makeAutoObservable } from "mobx";
import { openApi } from "../../../helpers/request";
import { FormEvent } from "react";
import i from "../../../translations/i";
import { notification } from "antd";

class AdditionalFieldsSystemController {

  items: any[] = []
  item: any = {
    field_name: '',
    enabled: true,
    placeholder: null,
    field_type: 'input',
    entity_type: 'user',
    depending_field_id: null,
    depending_value: true,
    fill_register: false,
    required_bonus_program: false,
    required_register: false,
    required_fill_order: false,
    depending: false,
    only_legal: false,
    removable: false,
    how_long_to_delete: 1,
    options: []
  }

  types: any[] = [
    {key: 'input', value: i.t('additionalFields:typeShortText')},
    {key: 'text', value: i.t('additionalFields:typeLongText')},
    {key: 'phone', value: i.t('additionalFields:typePhone')},
    {key: 'email', value: 'Email'},
    {key: 'radio', value: i.t('additionalFields:typeRadio')},
    {key: 'select', value: i.t('additionalFields:typeSelect')},
    {key: 'checkbox', value: i.t('additionalFields:typeCheckbox')},
    {key: 'file', value: i.t('def:file')},
  ]

  constructor() {
    makeAutoObservable(this)
  }

  getList() {
    openApi('get', '/additional_fields_system')
      .then(result => {
        console.log(result)
        this.items = result.data
      })
  }

  getOne(id: any) {
    if(id && id > 0) {
      openApi('get', `/additional_fields_system/${id}`)
        .then(result => {
          console.log(result)
          this.item = result.data
        })
    }
  }

  save(e: FormEvent) {
    e.preventDefault()

    const data = new FormData()
    data.append('enabled', `${+ this.item.enabled}`)
    data.append('field_name', this.item.field_name)
    if(this.item.placeholder) data.append('placeholder', this.item.placeholder)
    data.append('entity_type', this.item.entity_type)
    if(this.item.depending_field_id) data.append('depending_field_id', `${this.item.depending_field_id}`)
    data.append('depending_value', `${+ this.item.depending_value}`)
    data.append('fill_register', `${+ this.item.fill_register}`)
    data.append('required_bonus_program', `${+ this.item.required_bonus_program}`)
    data.append('required_register', `${+ this.item.required_register}`)
    data.append('required_fill_order', `${+ this.item.required_fill_order}`)
    data.append('depending', `${+ this.item.depending}`)
    data.append('only_legal', `${+ this.item.only_legal}`)
    data.append('removable', `${+ this.item.removable}`)
    data.append('how_long_to_delete', `${this.item.how_long_to_delete}`)

    let uri = this.item.id && this.item.id > 0 ? `/additional_fields_system/${this.item.id}` : '/additional_fields_system'

    openApi('post', uri, data)
      .then(result => {
        if(this.item.id && this.item.id > 0)
          window.location.reload()
        else
          window.location.href = '/settings/additional_fields_system'
      })
      .catch(error => {
        console.log(error.response)
        notification.error({
          message: i.t('def:errors.error'),
          description: error.response.data.data.message
        })
      })
  }

}

export default new AdditionalFieldsSystemController()